<!-- 订单控制台相关配置 -->
<template>
    <el-row style="margin: 20px  60px">
        <el-tabs v-model="activeName" type="card">
            <!-- 工艺管理 -->
            <el-tab-pane label="工艺管理" name="craftSetup">
                <!-- 新增工艺对话框 -->
                <el-dialog
                        title="新增工艺"
                        width="40%"
                        :append-to-body="true"
                        :visible.sync="createNewCraftShow">

                 <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="createNewCraftShow = false">取 消</el-button>
                 </span>
                </el-dialog>

                <!-- 修改工艺信息 -->
                <el-dialog
                        :append-to-body="true"
                        width="40%"
                        :visible.sync="updateCraftShow"
                        title="修改工艺信息">
                    <el-form label-width="auto">
                        <el-form-item label="工艺名称:" size="mini">
                            <el-input v-model="updateCraftData.name"></el-input>
                        </el-form-item>
                        <el-form-item label="所属工作台" size="mini">
                            <el-select v-model="updateCraftData.work_table">
                                <el-option :label="workTable.name" :value="workTable.id" :key="workTable.id"
                                           v-for="workTable in workTableArray"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item size="mini" label="是否停用:">
                            <el-select v-model="updateCraftData.is_using">
                                <el-option label="是" :value="false"></el-option>
                                <el-option label="否" :value="true"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item size="mini" label="是否必选:">
                            <el-select v-model="updateCraftData.is_must">
                                <el-option label="是" :value="true"></el-option>
                                <el-option label="否" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <el-button :loading="updateCraftLoading" @click="updateCraft" style="margin: 10px 0" size="mini"
                               type="primary">
                        更新
                    </el-button>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="updateCraftShow = false">取 消</el-button>
                    </div>
                </el-dialog>

                <el-table :data="craftInfoArray">
                    <el-table-column prop="name" label="名称"/>
                    <el-table-column prop="created_time" label="创建时间"/>
                    <el-table-column prop="mdf_time" label="最近一次修改"/>
                    <el-table-column prop="work_table_display" label="所属工作台"/>
                    <el-table-column prop="cost" label="基准价"/>
                    <el-table-column label="是否停用">
                        <template slot-scope="{row,column,$index}">
                            <el-tag v-if="!row.is_using" size="mini" type="danger">已停用</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="必选工艺">
                        <template slot-scope="{row,column,$index}">
                            <el-tag v-if="row.is_must" size="mini" type="primary">必选</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="功能">
                        <template slot-scope="{row,column,$index}">
                            <el-button @click="modifyCraftClick(row)" size="mini" type="primary">修改</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-row style="margin: 10px 0">
                    <el-button @click="createNewCraftShow=true" style="float: left;margin-right: 5px" size="mini"
                               type="primary">新增工艺
                    </el-button>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="工艺流程管理" name="craftProcessSetup">
                <!-- 工艺流程修改 -->
                <el-dialog
                        :append-to-body="true"
                        width="40%"
                        :visible.sync="updateCraftProcessShow"
                        title="工艺流程修改">
                    <!-- 表单数据 -->
                    <el-form :model="updateCraftProcessData" label-width="auto">
                        <el-form-item label="名称" size="mini">
                            <el-input v-model="updateCraftProcessData.name">
                            </el-input>
                        </el-form-item>

                        <el-form-item label="是否停用" size="mini">
                            <el-select v-model="updateCraftProcessData.selected">
                                <el-option :value="false" label="是"></el-option>
                                <el-option :value="true" label="否"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>

                    <el-button @click="updateCraftProcess" :loading="updateCraftProcessLoading" size="mini"
                               type="primary" style="margin: 10px 0">
                        保存
                    </el-button>
                </el-dialog>

                <el-dialog>

                </el-dialog>

                <el-table :data="craftProcessArray">
                    <el-table-column width="180" prop="name" label="名称"/>
                    <el-table-column align="center" width="150" prop="created_time" label="创建时间"/>
                    <el-table-column align="center" width="110" prop="used_nums" label="关联(款式)数量"/>
                    <el-table-column label="工艺流程路线">
                        <template slot-scope="{row}">
                            <el-tag
                                    style="margin: 0 4px"
                                    effect="plain"
                                    :type="row.selected ? 'primary' :'info'"
                                    size="mini"
                                    v-for="craftStep in row.craftprocessstep_set">
                                {{ craftStep.index }}.{{ craftStep.craft_expr.name }} {{ craftStep.selected }}
                            </el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column width="90" label="是否停用">
                        <template slot-scope="{row}">
                            <el-tag size="mini" type="danger" v-if="!row.selected">
                                停用
                            </el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column width="90" label="修改">
                        <template slot-scope="{row}">
                            <el-button @click="updateCraftProcessClick(row)" size="mini" type="primary">修改</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 新增工艺流程组件 -->
                <create-craft-process></create-craft-process>

            </el-tab-pane>
            <el-tab-pane label="工艺控制台管理" name="workSpace">
                <!-- 新增控制台对话框 -->
                <el-dialog
                        title="新增控制台"
                        width="40%"
                        @closed="newWorkTableData.name=''"
                        :visible.sync="createNewWorkTableShow"
                        :append-to-body="true">
                    <el-form label-width="auto">
                        <el-form-item size="mini" :required="true" label="控制台名称">
                            <el-input v-model="newWorkTableData.name">
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <el-button :loading="createNewWorkTableLoading" @click="createNewWorkTableClick"
                               style="margin: 10px 0;float: left" size="mini"
                               type="primary">
                        确认
                    </el-button>
                    <div slot="footer" class="dialog-footer">
                        <el-button size="mini" @click="createNewWorkTableShow = false">取 消</el-button>
                    </div>
                </el-dialog>
                <el-table :data="workTableArray">
                    <el-table-column prop="name" label="名称"></el-table-column>
                    <el-table-column prop="created" label="创建日期"></el-table-column>
                </el-table>
                <!-- 只有管理员可以使用该功能 -->
                <el-button :disabled="currentUserInfo.id !== 1"
                           @click="createNewWorkTableShow=true"
                           style="margin: 10px 0;float: left" size="mini"
                           type="primary">
                    新增控制台
                </el-button>
            </el-tab-pane>
            <el-tab-pane label="工厂管理" name="factorySetup">
                <factory-setup></factory-setup>
            </el-tab-pane>
            <el-tab-pane label="工厂小组管理" name="groupFactorySetup">
                <factory-group-setup></factory-group-setup>
            </el-tab-pane>
        </el-tabs>
    </el-row>

</template>

<script>
    import {mapGetters, mapMutations, mapState} from 'vuex'
    import FactorySetup from "./OrderSetupChildren/FactorySetup"
    import FactoryGroupSetup from "./OrderSetupChildren/FactoryGroupSetup"
    import CreateCraftProcess from "./OrderSetupChildren/CreateCraftProcess"

    export default {
        name: "OrderSetup",
        components: {CreateCraftProcess, FactoryGroupSetup, FactorySetup},
        data() {
            return {
                activeName: 'craftSetup',
                craftsUrl: '/goods/api/crafts/',                 // 工艺信息接口
                craftProcessUrl: this.$const.craftProcessUrl,    // 生产(工艺)路线信息接口

                createNewCraftShow: false,                        // 新增工艺对话框
                updateCraftShow: false,                            // 更改工艺对话框
                updateCraftLoading: false,
                updateCraftData: {                                  // 正在更改的工艺信息
                    id: '',
                    name: '',
                    work_table: '',
                    is_using: '',
                    is_must: '',
                },
                createNewWorkTableShow: false,
                newWorkTableData: {
                    name: '',
                },
                createNewWorkTableLoading: false,


                updateCraftProcessShow: false, // 工艺流程修改
                updateCraftProcessLoading: false,
                updateCraftProcessData: {
                    id: '',
                    name: '',
                    selected: '',
                },
            }
        },
        computed: {
            /**
             * 工艺控制台数据集
             */
            workTableArray() {
                return this.workTableData['workTableArray']
            },

            /**
             * 所有的工艺信息
             */
            craftInfoArray() {
                return this.craftInfoData['craftInfoArray']
            },

            /**
             * 所有的工艺模版信息
             */
            craftProcessArray() {
                return this.CraftProcessData['CraftProcessArray']
            },
            ...mapState(['currentUserInfo']),
            ...mapGetters(['CraftProcessData', 'craftInfoData', 'workTableData'])

        },
        methods: {
            /**
             * 修改工艺流程
             */
            updateCraftProcess() {
                if (!this.updateCraftProcessData.name) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: '名称为必填项'
                    })
                    return
                }
                this.updateCraftProcessLoading = true
                const url = `${this.craftProcessUrl}${this.updateCraftProcessData.id}/`
                const data = {
                    name: this.updateCraftProcessData.name,
                    selected: this.updateCraftProcessData.selected
                }
                this.$patchRequest(url, data)
                    .then(response => {
                        this.updateCraftProcessLoading = false
                        this.addCraftProcesses([response.data])
                        this.$message({
                            type: 'success',
                            showClose: true,
                            message: '完成工艺模版的更新'
                        })
                    })
                    .catch(error => {
                        this.updateCraftProcessLoading = false
                    })

            },

            /**
             * 点击修改工艺流程
             */
            updateCraftProcessClick(craftProcess) {
                this.updateCraftProcessShow = true
                // 初始化数据

                this.updateCraftProcessData.id = craftProcess.id
                this.updateCraftProcessData.name = craftProcess.name
                this.updateCraftProcessData.selected = craftProcess.selected

            },

            /**
             * 点击新增控制台
             */
            createNewWorkTableClick() {
                if (!this.newWorkTableData.name) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: '名称必须填写！'
                    })
                    return
                }

                this.createNewWorkTableLoading = true
                this.$postRequest(this.$const.workTableUrl, this.newWorkTableData)
                    .then(response => {
                        this.createNewWorkTableLoading = false
                        this.addWorkTables([response.data])
                    })
                    .catch(error => {
                        this.createNewWorkTableLoading = false
                    })
            },

            /**
             * 更新工艺记录单
             */
            updateCraft() {
                if (!this.updateCraftData.is_using && this.updateCraftData.is_must) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: '`停用` 与 `必选` 不能同时选择',
                    })
                    return
                }

                this.updateCraftLoading = true
                const data = {
                    name: this.updateCraftData.name,
                    work_table: this.updateCraftData.work_table,
                    is_using: this.updateCraftData.is_using,
                    is_must: this.updateCraftData.is_must
                }

                const url = `${this.craftsUrl}${this.updateCraftData.id}/`
                this.$patchRequest(url, data)
                    .then(response => {
                        this.updateCraftLoading = false
                        this.setCraftInfo(response.data)
                        this.$message({
                            type: 'success',
                            showClose: true,
                            message: '更新成功'
                        })
                    })
                    .catch(error => {
                        this.updateCraftLoading = false
                    })
            },

            /**
             * 点击修改工艺
             */
            modifyCraftClick(craft) {
                // 对 updateCraftData 进行刷新
                this.updateCraftData.id = craft.id
                this.updateCraftData.name = craft.name
                this.updateCraftData.work_table = craft.work_table
                this.updateCraftData.is_using = craft.is_using
                this.updateCraftData.is_must = craft.is_must

                this.updateCraftShow = true
            },

            /**
             * 加载工艺信息
             */
            loadCraftInfos() {
                if (this.craftInfoArray.length <= 0) {
                    this.$getRequest(this.craftsUrl)
                        .then(response => {
                            const craftInfos = response.data
                            this.addCraftInfos(craftInfos)

                        })
                        .catch(error => {
                            this.$message({
                                message: '加载工艺信息失败',
                                type: 'error',
                                showClose: true
                            })
                        })
                }
            },

            /**
             * 加载工艺流程模版
             */
            loadCraftProcesses() {
                if (this.craftProcessArray.length <= 0) {
                    const url = this.craftProcessUrl
                    this.$getRequest(url)
                        .then(response => {
                            this.addCraftProcesses(response.data)
                        })
                        .catch(error => {
                            this.$message({
                                type: 'error',
                                showClose: true,
                                message: '加载工艺模版选项失败'
                            })
                        })
                }
            },

            /**
             * 加载控制台信息
             */
            loadWorkTables() {
                if (this.workTableArray.length <= 0) {
                    const url = this.$const.workTableUrl
                    this.$getRequest(url)
                        .then(response => {
                            this.addWorkTables(response.data)
                        })
                        .catch(error => {
                            this.$message({
                                type: "error",
                                showClose: true,
                                message: '加载控制台信息出错'
                            })
                        })
                }
            },

            /**
             * 将 Vuex 中的 mutations 映射成组件中的方法
             */
            ...mapMutations([
                'addCraftProcesses', 'addCraftInfos', 'setCraftInfo', 'addWorkTables'
            ])
        },
        created() {
            this.loadCraftProcesses()
            this.loadCraftInfos()
            this.loadWorkTables()
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (vm.$route.params['activeName']) {
                    vm.activeName = vm.$route.params['activeName']
                }
            })
        }
    }
</script>

<style scoped>

</style>